import React, { useState } from 'react'
import { Box, Paper, Theme, Typography, useMediaQuery, useTheme } from '@mui/material'
import TextInputComponent, { TextFieldType } from '../../../shared/components/TextInputComponent'
import ButtonComponent from '../../../shared/components/ButtonComponent'
import Env from '../../../shared/config/envConfig'
import { setMessage } from '../../../store/settings/settings.actions'
import { Severity } from '../../../shared/types'
import { useHistory, useParams } from 'react-router-dom'

interface Props {
  token?: string | null
}

const ForgotPassword: React.FC<Props> = (props) => {
  const { token } = useParams<{ token?: string }>()

  const theme: Theme = useTheme()
  const history = useHistory()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const [newPassword, setNewPassword] = useState<string | undefined>()
  const [confirmPassword, setConfirmPassword] = useState<string | undefined>()
  const [showHint, setShowHint] = useState<boolean>(false)

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Passwort zurücksetzen</Typography>
      <Typography variant='body1'>Bitte gib nachfolgend dein neues Passwort ein und wiederhole es.<br />
        Dein neues Passwort muss:
      </Typography>
      <ul>
        <li>
          mindestens aus 8 Zeichen bestehen,
        </li>
        <li>
          mindestens einen Buchstaben enthalten,
        </li>
        <li>
          mindestens eine Zahl enthalten
        </li>
        <li>
          und mindestens ein Sonderzeichen (@$!%*#?&) enthalten.
        </li>
      </ul>
      <Box sx={{ width: '300px' }}>
        <TextInputComponent
          helperText='Das Passwort entspricht nicht den Richtlinien!'
          showError={showHint}
          size='small'
          type={TextFieldType.password}
          label='Neues Passwort'
          value={newPassword}
          required
          onChange={(value) => setNewPassword(value)}
        />
      </Box>
      <Box sx={{ width: '300px' }}>
        <TextInputComponent
          helperText='Das wiederholte Passwort stimmt nicht überein.'
          showError={!!((newPassword && newPassword !== confirmPassword))}
          size='small'
          type={TextFieldType.password}
          label='Neues Password wiederholen'
          value={confirmPassword}
          required
          onChange={(value) => setConfirmPassword(value)}
        />
      </Box>
      <Box sx={{ width: '300px' }}>
        <ButtonComponent
          size='medium'
          fullWidth
          disabled={!newPassword || !confirmPassword || newPassword !== confirmPassword}
          text='Neues Passwort setzen'
          onClick={() => {
            // checkPassword
            if (newPassword?.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)) {
              setShowHint(false)
              const fetchHeaders = Env.fetchHeaders

              const basePath = Env.restBase
              const restUrl = `${basePath}/api/session/resetPassword`
              fetch(restUrl,
                {
                  method: 'POST',
                  credentials: 'include',
                  headers: fetchHeaders,
                  body: JSON.stringify({
                    token: token,
                    newPassword: newPassword,
                  }),
                })
                .then(res => {
                  setMessage({ message: 'Passwort wurde zurückgesetzt', severity: Severity.success })
                  setNewPassword(undefined)
                  setConfirmPassword(undefined)
                  history.push('/login')
                })
                .catch(() => {
                  setMessage({
                    message: 'Ein unerwarteter Fehler. Bitte erneut versuchen.',
                    severity: Severity.error,
                  })
                })
            } else {
              setShowHint(true)
            }
          }}
        />
      </Box>
    </Paper>
  )
}

export default ForgotPassword
